<template>
  <div class="login">
    <form action="" class="fm" @submit.prevent="login">
      <h3>欢迎登录一线快递 <span v-if="this.$route.query.type == 'merchant'">(商家版)</span></h3>
      <div class="item">
        <span>账户</span>
        <input type="tel" placeholder="请选择登录账户" maxlength="11" v-model="mobile" >
      </div>
      <div class="item">
        <span>密码</span>
        <input type="text" placeholder="请输入登录密码" v-model="password" v-if="bool">
        <input type="password" placeholder="请输入登录密码" v-model="password" v-else>
        <img src="../../assets/images/login/close.png" alt="" @click="open2" v-if="bool">
        <img src="../../assets/images/login/open.png" alt="" @click="open2" v-else>
      </div>
      <div class="remember">
        <!--<div class="left">-->
          <!--<input type="checkbox">-->
          <!--<span>记住密码</span>-->
        <!--</div>-->
        <div class="right"><router-link to="/findPassword">忘记密码</router-link>？</div>
      </div>
      <button class="btn">登录</button>
      <p class="tiparea">没有账号？点击<span @click="register">注册</span></p>
    </form>
  </div>
</template>

<script>
import {reqLogin} from '../../api/index'
export default {
  data() {
    return {
      bool: false,
      mobile: '', // 账户
      password: '', // 密码
    }
  },
  methods: {
    // 登录
    login () {
      const type = this.$route.query.type == 'merchant' ? 1 : 0;
      const data = `?mobile=${this.mobile}&password=${this.password}&type=` + type
      reqLogin(data).then(res => {
        if(res.code === 200){
          this.$message({
            message: '登录成功',
            type: 'success'
          })
          // 存储本地
          localStorage.setItem('sessionId', res.data.bussData.sessionId)
          localStorage.setItem('userInfo', res.data.bussData.mobile)
          this.$store.dispatch('recordUserBaseInfo')
          this.$router.replace('/')
        }else if (res.code === 500) {
          this.$message({
            message: res.data.errMsg,
            type: 'error'
          })
        }

      })
    },
    // 点击注册
    register () {
      this.$router.push('/normalRegister')
    },
    open2 () {
      this.bool = !this.bool
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
  .login{
    height: 828px;
    background: url('../../assets/images/login/login_bg.png') no-repeat;
    padding-top:160px;
    form{
      width: 600px;
      height: 509px;
      margin:0 auto 0;
      padding:50px 125px 65px;
      box-sizing: border-box;
      background: #fff;
      h3{
        font-size: 32px;
        font-family:MicrosoftYaHei;
        color:#1a1a1a;
        margin-bottom: 40px;
        text-align: center;
        span{
          font-size: 18px;
          color:red;
        }
      }
      .item{
        height: 70px;
        margin-top:12px;
        font-size: 16px;
        color: #666;
        line-height: 70px;
        border-bottom: 2px solid #EAEAEF;
        span{
          display: inline-block;
          width: 78px;
        }
        input{
          width: 232px;
          height: 67px;
          &:focus{outline:none;}
        }
        img{
          cursor: pointer;
        }
      }
      .remember{
        margin-top:12px;
        overflow: hidden;
        color:#999;
        .left{
          float: left;
        }
        .right{
          float: right;
        }
      }
      .btn{
        width: 100%;
        height: 54px;
        margin-top:40px;
        margin-bottom: 20px;
        background: #2FA1DE;
        color:#fff;
        border-radius:27px;
        font-size: 18px;
        border:none;
      }
      .tiparea{
        text-align: right;
        color:#999;
        span{
          color:#2FA1DE;
          cursor: pointer;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Login/Login.vue